import _slicedToArray from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { dynamicQuoteApplyURL, getReferrerKeys, updatePhoneNumber } from './campaigns';
import { cookie } from '../util/storage';
var campaignData;
var folderName = location.pathname;
var isMedSupp = folderName.match(/(?=.*medicare)(?=.*supplemental)|(?=.*medicare-campaigns)|(?=.*medicare-advantage)/gm) !== null;
var isCSB = folderName.match(/(?=.*csb)/gm) !== null;

var organic = function organic(cookieToCheck) {
  var campaignToUse = isMedSupp ? 'CSBORG' : 'ANCORG';
  var referrerInfo = {
    google: [campaignToUse, 'Google_Search'],
    bing: [campaignToUse, 'Bing_Search'],
    yahoo: [campaignToUse, 'Yahoo_Search'],
    cigna: [campaignToUse, 'Other_Cigna_page'],
    default: [campaignToUse, 'Typed_URL']
  };

  var _getReferrerKeys = getReferrerKeys(referrerInfo),
      _getReferrerKeys2 = _slicedToArray(_getReferrerKeys, 2),
      referrerCode = _getReferrerKeys2[0],
      referrerValue = _getReferrerKeys2[1];

  if (['csbMedCampaign', 'campaignPID', 'campaignEID'].some(function (e) {
    return cookieToCheck === e;
  })) {
    cookie.set(cookieToCheck, referrerCode);
    var defaultPhone = $('.campaign-phone-number a').first().text().trim();
    var phoneNumber = campaignData[referrerCode] || defaultPhone;
    var format = true;
    if (folderName.match(/(?=.*medicare-advantage)/gm) !== null) format = false;

    if (cookieToCheck === 'csbMedCampaign') {
      // eslint-disable-next-line max-len
      if (isMedSupp && phoneNumber || isCSB && phoneNumber) updatePhoneNumber(phoneNumber, format);
      dynamicQuoteApplyURL(referrerCode);
    }
  } else if (['campaignMedium', 'campaignSource'].some(function (e) {
    return cookieToCheck === e;
  })) {
    if (cookieToCheck === 'campaignMedium') {
      var mediumToUse = isMedSupp ? referrerValue : 'Cigna Supplemental';
      cookie.set(cookieToCheck, mediumToUse);
    } else {
      cookie.set(cookieToCheck, referrerValue);
    }
  }

  if (!isMedSupp) {
    var pages = {
      'accident-expense-insurance': '18553588529',
      'cancer-insurance': '18553588530',
      'heart-stroke-insurance': '18553588531',
      'whole-life-insurance': '18553588533',
      'cancer-treatment-insurance': '18553588532',
      'hospital-indemnity-insurance': '18776308501',
      default: '18553588528'
    };
    var files = Object.keys(pages);
    var lookupPhone = files.find(function (e) {
      return folderName.includes(e);
    }) || 'default';
    updatePhoneNumber(pages[lookupPhone]);
  }
};

var updateCampaign = function updateCampaign(key, val) {
  if (val && val !== 'ANCORG' && val !== 'CSBORG' && val !== 'Cigna Supplemental') {
    if (key === 'csbMedCampaign' || key === 'utm_campaign') {
      if (campaignData[val] && isMedSupp || campaignData[val] && isCSB) {
        cookie.set('csbMedCampaign', val);

        if (folderName.match(/(?=.*medicare-advantage)/gm) !== null) {
          updatePhoneNumber(campaignData[val], false);
        } else {
          updatePhoneNumber(campaignData[val]);
        }

        dynamicQuoteApplyURL(val);
      } else {
        organic('csbMedCampaign');
      }
    } else if (key === 'campaignMedium' || key === 'utm_medium') {
      cookie.set('campaignMedium', val);
    } else if (key === 'campaignSource' || key === 'utm_source') {
      cookie.set('campaignSource', val);
    } else if (key === 'campaignPID' || key === 'PID') {
      cookie.set('campaignPID', val);
    } else if (key === 'campaignEID' || key === 'EID') {
      cookie.set('campaignEID', val);
    }
  } else {
    organic(key);
  }
};

var processCampaignURL = function processCampaignURL() {
  if (location.search === '') {
    ['campaignMedium', 'campaignSource', 'campaignPID', 'campaignEID', 'csbMedCampaign'].forEach(function (element) {
      return organic(element);
    });
  } else {
    var _location$search$spli = location.search.split('?'),
        _location$search$spli2 = _slicedToArray(_location$search$spli, 2),
        searchString = _location$search$spli2[1];

    var searchValuesObj = {};
    searchString.split('&').forEach(function (element) {
      var _element$split = element.split('='),
          _element$split2 = _slicedToArray(_element$split, 2),
          key = _element$split2[0],
          val = _element$split2[1];

      searchValuesObj[key] = val;
    });
    /* eslint-disable no-confusing-arrow */

    [{
      query: 'utm_medium',
      cookie: 'campaignMedium'
    }, {
      query: 'utm_source',
      cookie: 'campaignSource'
    }, {
      query: 'PID',
      cookie: 'campaignPID'
    }, {
      query: 'EID',
      cookie: 'campaignEID'
    }, {
      query: 'utm_campaign',
      cookie: 'csbMedCampaign'
    }].forEach(function (element) {
      return searchValuesObj[element.query] ? updateCampaign(element.query, searchValuesObj[element.query]) : updateCampaign(element.cookie);
    });
  }
};

export default (function (jsonData) {
  campaignData = jsonData;

  if (cookie.get('csbMedCampaign') && !location.search.includes('utm_campaign')) {
    ['campaignMedium', 'campaignSource', 'campaignPID', 'campaignEID', 'csbMedCampaign'].forEach(function (element) {
      return updateCampaign(element, cookie.get(element));
    });
  } else {
    processCampaignURL();
  }
});